import Vue from 'vue';
// import Router from 'vue-router'
import VueRouter from 'vue-router';
//Import views
import Main from '@/views/Main';

//Import webpage components
import WebHome from '@/components/webpage/WebHome';
import WebAboutUs from '@/components/webpage/WebAboutUs';
import WebOurServices from '@/components/webpage/WebOurServices';
import WebSupplier from '@/components/webpage/WebSupplier';
import WebWhyUs from '@/components/webpage/WebWhyUs';
import WebContact from '@/components/webpage/WebContact';
import WebComingSoon from '@/components/webpage/WebComingSoon';
import WebFAQ from '@/components/webpage/WebFAQ';
import ThankYou from '@/components/webpage/ThankYou';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      redirect: '/home',
    },
    {
      path: '/',
      name: 'main',
      component: Main,
      children: [{
          path: '/home',
          name: 'webhome',
          component: WebHome
        },
        {
          path: '/whyus',
          name: 'whyus',
          component: WebWhyUs
        },
        {
          path: '/contact',
          name: 'contact',
          component: WebContact
        },
        {
          path: '/thankyou',
          name: 'thankyou',
          component: ThankYou
        },
        {
          path: '/comingsoon',
          name: 'comingsoon',
          component: WebComingSoon
        },
        {
          path: '/supplier',
          name: 'websupplier',
          component: WebSupplier
        },
        {
          path: '/aboutus',
          name: 'webaboutus',
          component: WebAboutUs
        },
        {
          path: '/ourservices',
          name: 'webourservices',
          component: WebOurServices
        },
        {
          path: '/frequentquestions',
          name: 'webfaq',
          component: WebFAQ
        }
      ]
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})